"use strict";
/**
 * This is the source of truth for all cart sources
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.cartSources = exports.atcSources = void 0;
const cartSources = {
    BUNDLE: 'bundle',
    CART: 'update',
    GIFT_GUIDE: 'giftGuide',
    PDP: 'detail',
    RANGE: 'range',
    SEARCH: 'search',
    SHOP: 'shop',
    SUBCAT: 'subcat',
    CMS: 'cms',
};
exports.cartSources = cartSources;
// to track what CTA was clicked for adding items to cart
const atcSources = {
    STICKY: 'sticky',
};
exports.atcSources = atcSources;
//# sourceMappingURL=cartSources.js.map